<ion-app [class.ion-palette-dark]="dark">
     <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
